module.exports = __webpack_public_path__ + "img/Box-Theme.71b05582.png";